import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, Tag } from 'antd';
import moment from 'moment';
import './styles.css';
import { message } from 'antd';

import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';

import DetalleProductoServicioModal from './FormModal/DetalleProductoServicioModal';
import DetalleReferenciaModal from './FormModal/DetalleReferenciaModal';
import TotalDetalle from './FormModal/TotalModal';

import auth from '../../../common/utility/auth';
import global from '../../../common/utility/global';

import { REGISTRADO } from '../../../common/types/ordenProduccionEstadoType';
import { ORDEN_PRODUCCION } from '../../../common/types/tipoComprobanteType';


const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    findDaysAndDates = (property, value) => {
        if (property === 'diasVencimiento') {
            const fecha = moment(this.props.form.getFieldValue('fechaStr'), 'DD/MM/YYYY');
            const diasVencimiento = parseInt(value);
            this.props.form.setFieldsValue({ fechaVencimientoStr: fecha.add('days', diasVencimiento) });
        }

        if (property === 'fechaVencimientoStr') {
            const fecha = moment(this.props.form.getFieldValue('fechaStr'), 'DD/MM/YYYY');
            const fechaVencimiento = moment(value, 'DD/MM/YYYY');
            this.props.form.setFieldsValue({ diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString() });
        }

        if (property === 'fechaStr') {
            const fechaVencimiento = moment(this.props.form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const fecha = moment(value, 'DD/MM/YYYY');
            const mf = fecha.format('YYYY/MM/DD');
            console.log('cambio 2');
            // const minFechaStr = fecha.format('DD/MM/YYYY')
            this.props.form.setFieldsValue({ diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString(), minFechaStr: mf });
            //this.props.form.setFieldsValue({ minFechaStr: mf });
        }
    };

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }

    handleRemoverProducto = (identifier) => {
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== "psd" + identifier });
        //var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== identifier });
        var _sumaSubTotal = 0;
        arrDetalleFilter.forEach(item => {
            _sumaSubTotal = _sumaSubTotal + item.subTotal;
        });

        //var sumaImporteDescuento = this.fetchFieldValueSum("psd" + identifier, "arrImporteDescuento", 0);
        //var sumaIsc = this.fetchFieldValueSum("psd" + identifier, "arrIsc", 0);
        var sumaTotal = this.fetchFieldValueSum("psd" + identifier, "arrTotal", 0);
        var sumaSubTotal = _sumaSubTotal;
        var sumaIgv = sumaTotal - sumaSubTotal;
        //var sumaTotalDetalle = sumaSubTotal - sumaImporteDescuento;

        this.props.form.setFieldsValue({
        //    sumaImporteDescuento: sumaImporteDescuento,
        //    sumaIsc: sumaIsc,
            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,
        //    sumaTotalDetalle: sumaTotalDetalle,
            arrDetalle: arrDetalleFilter
        });

        this.props.onRemoverProducto(identifier);
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {

                var porcentajeIGV = 18;

                const form = {
                    "id": values.id,
                    "idMoneda": values.idMoneda.key,
                    "idProveedor": values.idProveedor.key,
                    "idProyecto": values.idProyecto === undefined ? 0 : values.idProyecto.key,
                    "idEstablecimiento": values.idEstablecimiento.key,
                    "idAlmacen": values.idAlmacen.key,
                    "idOrdenProduccionEstado": REGISTRADO,
                    "fecha": null,
                    "fechaStr": values.fechaStr.format('DD/MM/YYYY'),
                    "tipoCambio": parseFloat(values.tipoCambio),
                    "idTipoComprobante": ORDEN_PRODUCCION.ID,
                    "serie": values.serie,
                    "documento": null,
                    "diasVencimiento": parseInt(values.diasVencimiento),
                    "fechaVencimiento": null,
                    "fechaVencimientoStr": values.fechaVencimientoStr.format('DD/MM/YYYY'),
                    "porcentajeIGV": porcentajeIGV,
                    "subTotal": values.sumaSubTotal,
                    "igv": values.sumaIgv,
                    "total": values.sumaTotal,
                    "observacion": values.observacion,
                    "observacionRechazado": null,
                    "idRequerimiento": values.idRequerimiento,
                    "ordenProduccionDetalles": [],
                    "ordenProduccionReferencias": []
                }

                //Referencias-->
                if (values.idTipoComprobante !== undefined) {
                    var count_referencias = values.idTipoComprobante.length;// - 1;
                    for (var i = 0; i < count_referencias; i++) {
                        var tc = values.idTipoComprobante[i];
                        if (tc !== undefined) {

                            const itemRef = {
                                "id": 0,
                                "idOrdenProduccion": 0,
                                "idReferenciaOrigen": values.arrIdReferenciaOrigen[i],
                                "idReferencia":values.arrIdReferencia[i],
                                "idTipoComprobante": tc.key,
                                "serie": values.series[i],
                                "documento": values.documentos[i],
                                "flagInterno": values.arrFlagInterno[i],
                            }

                            form.ordenProduccionReferencias.push(itemRef);
                        }
                    }
                }

                if (values.arrDetalle.length <= 0) {
                    message.warning('Debe de ingresar como mínimo 1 producto.');
                    return;
                }
                if (values.sumaTotal === 0) {
                    message.warning('Por favor ingrese lo montos de forma correcta.');
                    return;
                }

                //Detalles----->
                var count_detalles = values.arrDetalle.length;
                for (var i = 0; i < count_detalles; i++) {
                    var det = values.arrDetalle[i];
                    
                    const itemDet = {
                        "id": 0,
                        "idOrdenProduccion": null,
                        "idProducto": parseInt(det.idProducto),
                        "nombre": det.nombre,
                        "flagAfecto": det.flagAfecto,
                        "cantidad": det.cantidad,
                        "precioUnitario": det.precioUnitario,
                        "subTotal": det.subTotal,
                        "igv": det.igv,
                        "total": det.total
                    }

                    form.ordenProduccionDetalles.push(itemDet);
                }

                this.props.onSave(form, this.props.form);
            }
        });
    };

    fetchNewValue = (value, numberDecimals) => {
        if (numberDecimals === 2)
            return value === '' || isNaN(parseFloat(value).toFixed(2)) ? 0 : parseFloat(value);
        if (numberDecimals === 3)
            return value === '' || isNaN(parseFloat(value).toFixed(3)) ? 0 : parseFloat(value);
        if (numberDecimals === 5)
            return value === '' || isNaN(parseFloat(value).toFixed(5)) ? 0 : parseFloat(value);
        if (numberDecimals === 0)
            return value === '' || isNaN(parseFloat(value).toFixed(0)) ? 0 : parseFloat(value);

        return 0;
    };

    fetchFieldValue = (identifier, property) => {
        var result = parseFloat(this.props.form.getFieldValue(`${property}[${identifier}]`));
        return result;
    };

    fetchFieldValueSum = (identifier, property, paramValue) => {
        var suma = 0;
        var obj = Object.assign({}, this.props.form.getFieldValue(property));

        for (var [key, value] of Object.entries(obj)) {
            suma = suma + (key === identifier ? paramValue : parseFloat(value));
        }

        return suma;
    };

    handleCalculateDetail = (identifier, property, value, numberDecimals, row) => {
        var newValue = this.fetchNewValue(value, numberDecimals);

        /********* Datos de parametro ******/
        var porcentajeIGV = 18;

        /*********** Datos por fila ********/
        var flagAfecto = property === "arrFlagAfecto" ? value : this.props.form.getFieldValue(`arrFlagAfecto[${identifier}]`);
        var cantidad = property === "arrCantidad" ? newValue : this.fetchFieldValue(identifier, "arrCantidad");
        var precioUnitario = property === "arrPrecioUnitario" ? newValue : this.fetchFieldValue(identifier, "arrPrecioUnitario");
        var total = property === "arrTotal" ? newValue : this.fetchFieldValue(identifier, "arrTotal");

        /*********** Calculo precios unitarios ********/
        //var divisorCalculoSubTotal = 1 + (porcentajeIGV / 100);
        //var precioUnitarioSinIGV = flagPrecioIncluyeIGV ? precioUnitario / divisorCalculoSubTotal : precioUnitario;
        //var precioUnitarioConIGV = flagPrecioIncluyeIGV ? precioUnitario : precioUnitario * (porcentajeIGV / 100);
        

        var totalDetalle = cantidad * precioUnitario;//precioUnitarioSinIGV;

        /*********** Calculo totales ********/
        var subTotal = totalDetalle;
        var igv = parseFloat((flagAfecto ? (subTotal * (porcentajeIGV / 100)) : 0).toFixed(2));
        var total = parseFloat(((subTotal + igv)).toFixed(2));

        //if (property === "arrTotal") {
        //    /*********** Calculo totales ********/
        //    total = parseFloat(value);
        //    subTotal = flagPrecioIncluyeIGV ? total / (1 + (porcentajeIGV / 100)) : total;

        //    /*********** Calculo Cantidad ********/
        //    cantidad = totalDetalle / precioUnitarioSinIGV;

        //    /*********** Calculo IGV ********/
        //    igv = flagAfecto ? (subTotal * (porcentajeIGV / 100)) : 0;
        //}


        /*********** Arr Detalle ********/
        var detalle = {
            identifier,
            flagAfecto,
            precioUnitario,
            cantidad,
            subTotal: parseFloat(subTotal.toFixed(2)),
            igv,
            total,
            idProducto: identifier.substring(3),
            nombre: row.nombre
        };
        debugger
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var arrDetalleFilter = arrDetalle.filter(m => { return m.identifier !== identifier });
        arrDetalleFilter.push(detalle);

        var _sumaSubTotal = 0;
        arrDetalleFilter.forEach(item => {
            _sumaSubTotal = _sumaSubTotal + item.subTotal;
        });

        /*********** Calculo suma detalle ********/
        //var sumaImporteDescuento = this.fetchFieldValueSum(identifier, "arrImporteDescuento", importeDescuento);
        //var sumaIsc = this.fetchFieldValueSum(identifier, "arrIsc", cantidad === 0 ? 0 : importeISC);
        var sumaTotal = this.fetchFieldValueSum(identifier, "arrTotal", total);
        var sumaSubTotal = _sumaSubTotal;
        var sumaIgv = sumaTotal - sumaSubTotal;
        //var sumaTotalDetalle = sumaSubTotal - sumaImporteDescuento;

        this.props.form.setFieldsValue({
            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,
            //sumaTotalDetalle: sumaTotalDetalle,
            arrDetalle: arrDetalleFilter,
            [`arrFlagAfecto[${identifier}]`]: flagAfecto,
            //[`arrFlagGratuito[${identifier}]`]: flagGratuito,
            //[`arrFlagISC[${identifier}]`]: flagISC,
            //[`arrIsc[${identifier}]`]: cantidad === 0 ? 0 : importeISC,
            [`arrPrecioUnitario[${identifier}]`]: precioUnitario.toFixed(5),
            [`arrCantidad[${identifier}]`]: cantidad.toFixed(3),
            //[`arrTotalDetalle[${identifier}]`]: totalDetalle.toFixed(2),
            //[`arrPorcentajeDescuento[${identifier}]`]: porcentajeDescuento.toFixed(2),
            //[`arrImporteDescuento[${identifier}]`]: importeDescuento.toFixed(2),
            [`arrSubTotal[${identifier}]`]: subTotal.toFixed(2),
            [`arrIgv[${identifier}]`]: igv.toFixed(2),
            [`arrTotal[${identifier}]`]: total.toFixed(2)
        });

        this.props.form.setFieldsValue({
            arrDetalle: arrDetalleFilter
        });
    };

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.props.onChangeNameProduct(row);
    }

    handleSearchAutocompleteProveedor = async (value) => {
        const result = this.props.formValues.proveedores.filter(item => {
            return global.formatSearch(`${item.nombre} - ${item.tipoDocumento}`).match(global.formatSearch(value));
        }).slice(0, 75);
        this.props.form.setFieldsValue({ proveedores: result });
    }

    handleChangeAutocompleteProveedor = async (a, element) => {
        console.log(element.props.data);
        this.props.form.setFieldsValue({
            documentoProveedor: element.props.data.numeroDocumento
        }, () => {
            this.props.onChange("idProveedor", element.props.data.idEntidad, this.props.form)
        });
    }

    render() {
        //debugger
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        var arrayTemp = [];
        var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        for (var i = 0; i < this.props.formValues.listaComprobanteDetalle.length; i++) {
            var item = this.props.formValues.listaComprobanteDetalle[i];
            var existItem = arrDetalle.filter(m => { return m.identifier === item.idProducto })
            
            var d = {
                identifier: 'psd' + item.idProducto,
                flagAfecto: false,
                idProducto: item.idProducto,
                precioUnitario: existItem.length === 0 ? item.precioUnitario : existItem[0].precioUnitario,
                cantidad: existItem.length === 0 ? item.cantidad : existItem[0].cantidad,
                subTotal: existItem.length === 0 ? item.subTotal : existItem[0].subTotal,
                igv: existItem.length === 0 ? item.igv : existItem[0].igv,
                total: existItem.length === 0 ? item.total : existItem[0].total,
                nombre: item.nombre
            };

            arrayTemp.push(d);
        }

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        //getFieldDecorator('arrDetalle', { initialValue: [] });
        getFieldDecorator('arrDetalle', { initialValue: arrayTemp });
        //getFieldDecorator('arrDetalle', { initialValue: this.props.formValues.listaComprobanteDetalle });
        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });
        getFieldDecorator('proveedores', {initialValue: this.props.formValues.proveedores.filter(m => { return m.idEntidad === this.props.formValues.idProveedor }) });

        return (
            <Modal
                title={(<div> {this.props.formValues.id === 0 ? `Registrar Orden de Produccion` : `Modificar Orden de Produccion`}</div>)}
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1100px"
            >
                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('minFechaStr', { initialValue: this.props.formValues.minFechaStr })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('idRequerimiento', { initialValue: this.props.formValues.idRequerimiento })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Fecha Producción / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) => {
                                                    this.props.onChange('fechaStr', value);
                                                    this.findDaysAndDates('fechaStr', value);
                                                }}
                                                
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Dias / Fecha de Vencimiento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('diasVencimiento', {
                                            initialValue: this.props.formValues.diasVencimiento,
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_NUMBER),
                                                message: "Formato incorrecto"
                                            }]
                                        })(
                                            <Input
                                                style={{ textAlign: 'right' }}
                                                placeholder="Ingresar días de vencimiento"
                                                autoComplete="off"
                                                className="first-input"
                                                onBlur={(e) => this.findDaysAndDates('diasVencimiento', e.target.value)}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaVencimientoStr', {
                                            initialValue: moment(this.props.formValues.fechaVencimientoStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                className="second-input"
                                                onChange={(moment, value) => this.findDaysAndDates('fechaVencimientoStr', value)}
                                                disabledDate={d => !d || d.isBefore(this.props.form.getFieldValue('minFechaStr'))}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idMoneda', option.key)}
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Proveedor">
                                <InputGroup compact>
                                     <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('documentoProveedor', {
                                            initialValue: this.props.formValues.documentoProveedor,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Search
                                                placeholder="Nro. Documento"
                                                className="first-input"
                                                autoComplete="off"
                                                loading={this.props.formValues.proveedorLoading}
                                                onSearch={value => this.props.onBuscarProveedor(value)}
                                            />
                                        )}
                                    </Form.Item> 
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('idProveedor', {
                                            initialValue: this.props.formValues.idProveedor ?
                                                { key: this.props.formValues.idProveedor } : undefined,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Select showSearch labelInValue
                                                placeholder={"Seleccione Proveedor"}
                                                optionFilterProp="children"
                                                className="second-input"
                                                onSearch={this.handleSearchAutocompleteProveedor}
                                                onChange={this.handleChangeAutocompleteProveedor}
                                            >
                                                {                                                
                                                this.props.formValues.proveedores.map(item => (
                                                    <Option
                                                        key={item.id}
                                                        value={item.id}
                                                        data={item}
                                                    >
                                                        <Tag>{item.tipoDocumentoNombre}</Tag>{`${item.nombre}-${item.numeroDocumento}`}
                                                    </Option>
                                                ))
                                                
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Dirección">
                                {getFieldDecorator('idEstablecimientoProveedor', {
                                    initialValue: this.props.formValues.idEstablecimientoProveedor ?
                                        { key: this.props.formValues.idEstablecimientoProveedor } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Dirección"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.direcciones.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre + ' - ' + item.direccion}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 form-group">
                            <Form.Item label="Producto Terminado">
                                {getFieldDecorator('idProductoTerminado', {
                                    initialValue: this.props.formValues.idProductoTerminado ?
                                        { key: this.props.formValues.idProductoTerminado } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Producto"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idProductoTerminado', option.key)}
                                    >
                                        {this.props.formValues.productos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Receta de Producción">
                                {getFieldDecorator('idReceta', {
                                    initialValue: this.props.formValues.idReceta ?
                                        { key: this.props.formValues.idReceta } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Receta"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen: undefined });
                                            this.props.onChange("idReceta", option.key)
                                        }}
                                    >
                                        {this.props.formValues.recetas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Cantidad">
                                        {getFieldDecorator('cantidad', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Cantidad"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("cantidad", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>

                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-3 form-group">
                            <Form.Item label="Sucursal">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.idEstablecimiento ?
                                        { key: this.props.formValues.idEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen: undefined });
                                            this.props.onChange("idEstablecimiento", option.key)
                                        }}
                                    >
                                        {this.props.formValues.establecimientos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    <div className="col-md-3 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacen', {
                                    initialValue: this.props.formValues.idAlmacen ?
                                        { key: this.props.formValues.idAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        loading={this.props.formValues.almacenLoading}
                                    >
                                        {this.props.formValues.almacenes.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-12 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                // tabBarExtraContent={
                                //     <Button
                                //         icon="plus"
                                //         type="primary"
                                //         onClick={this.props.onAgregarDetalle}
                                //     >
                                //         Agregar
                                //     </Button>
                                // }
                                tabBarExtraContent={
                                    <div className="custom-options">
                                <Button
                                    icon="import"
                                    type="primary"
                                    onClick={this.props.onImportarRequerimiento}
                                >
                                    Importar Requerimiento
                                </Button>
                                    <Button
                                        icon="plus"
                                        type="primary"
                                        onClick={this.props.onAgregarDetalle}
                                    >
                                        Agregar
                                    </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <DetalleProductoServicioModal
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        onRemove={this.handleRemoverProducto}
                                        onCalculateDetail={this.handleCalculateDetail}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                        onChangeNameProduct={this.handleChangeNameProduct}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <DetalleReferenciaModal
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        tiposComprobante={this.props.formValues.tiposComprobante}
                                        onRemove={this.props.onRemoverReferencia}
                                        onGetFieldDecorator={getFieldDecorator}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <TotalDetalle
                        formValues={this.props.formValues}
                        onGetFieldDecorator={getFieldDecorator}
                        onGetFieldValue={getFieldValue}
                    />
                </Form>
            </Modal>
        )
    }
}
export default Form.create()(FormModal)